import axios from "axios";
 
const API_URL = process.env.React_App_BASE_URL_API+'/api/';
const Login_url = API_URL+"employee/login";



class AuthService {
  login(email, password) {
    return axios
      .post(Login_url, {email,password})
      .then(response => {
          if (response.data.accessToken) {
            localStorage.setItem("user", JSON.stringify(response.data));
          }
          return response.data;         
      });
  }

  logout() {
    localStorage.removeItem("user");
  }

  register(username, email, password) {
    return axios.post(API_URL + "signup", {
      username,
      email,
      password
    });
  }

  getCurrentUser() {
    return JSON.parse(localStorage.getItem('user'));
  }
}

export default new AuthService();
